import { render, staticRenderFns } from "./AdsHome.vue?vue&type=template&id=e0ba9f8a&"
import script from "./AdsHome.vue?vue&type=script&lang=js&"
export * from "./AdsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports